import React from 'react'
import Image from 'next/image'

// Import all SVGs
import appleSvg from '@/public/assets/icons/apple.svg'
import facebookSvg from '@/public/assets/icons/facebook.svg'
import googleSvg from '@/public/assets/icons/google.svg'
import greenTickSvg from '@/public/assets/icons/green_tick.svg'
import mainLogoSvg from '@/public/assets/icons/mainlogo.svg'
import redLineSvg from '@/public/assets/icons/redline.svg'
import verifySvg from '@/public/assets/icons/verify.svg'

// Map of icon names to their import paths
const iconMap = {
  apple: appleSvg,
  facebook: facebookSvg,
  google: googleSvg,
  greenTick: greenTickSvg,
  mainLogo: mainLogoSvg,
  redLine: redLineSvg,
  verify: verifySvg,
}

export type IconName = keyof typeof iconMap

interface SvgIconProps {
  name: IconName
  size?: number
  className?: string
  alt?: string
}

const SvgIcon = ({ name, size = 24, className = '', alt = '' }: SvgIconProps) => {
  const iconSrc = iconMap[name]
  
  if (!iconSrc) {
    return null
  }

  return (
    <Image 
      src={iconSrc} 
      width={size} 
      height={size} 
      className={className} 
      alt={alt || `${name} icon`} 
    />
  )
}

export default SvgIcon 